export default __webpack_public_path__ + "static/media/Vtech.6b9a60f3.png";